"use strict";

/**
 * Map Factory
 * @namespace Factories
 */
(function () {
  'use strict';

  angular.module('lr.Map').factory('MapFactory', MapFactory);
  MapFactory.$inject = ['Utils', 'PropertyStateValue', 'GuestState'];
  /**
   * @namespace MapFactory
   * @desc contains the classes for our Map Directive
   * @memberOf Factories
   */

  /* @ngInject */

  function MapFactory(Utils, PropertyStateValue, GuestState) {
    /**
     *
     * @param map map instance
     * @param args class defaults
     * @constructor
     */
    function Map(map, args) {
      this.bounds = [];
      this.pins = {};
      this.mapInstance = map.map(args.id, {
        scrollWheelZoom: args.scrollWheelZoom
      }).setView([args.lat, args["long"]], args.zoom);
      map.tileLayer(args.tileServer, {
        maxZoom: args.maxZoom,
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.mapInstance);
    }
    /**
     * @name resetData
     * @desc reset the bounds and pins
     * @returns
     * @memberOf Map
     */


    Map.prototype.resetData = function () {
      this.pins = {};
      this.bounds = [];
    };
    /**
     * @name createPin
     * @desc calls mapPinFactory to create a pin depending on pin type
     * @param pinData
     * @returns pinData
     * @memberOf Map
     */


    Map.prototype.createPin = function (pinData) {
      var pin = {}; //create Property Pin

      if (pinData.hasOwnProperty('latitude') && pinData.hasOwnProperty('longitude') && Utils.validLatLong(pinData.latitude, pinData.longitude)) {
        pin = mapPinFactory('property', pinData);
        this.pins[pinData.pid] = pin;
        this.bounds.push([pin.lat, pin["long"]]);
      } //create event pin


      if (pinData.hasOwnProperty('propertyLatitude') && pinData.hasOwnProperty('propertyLongitude') && Utils.validLatLong(pinData.propertyLatitude, pinData.propertyLongitude)) {
        //if we have the pin already
        //add the pin data to the pin events array
        //regenerate the pin text
        if (this.pins[pinData.pid]) {
          if (this.pins[pinData.pid].hasOwnProperty('events')) {
            this.pins[pinData.pid].events.push(pinData);
            this.pins[pinData.pid].setText();
          }
        } else {
          pin = mapPinFactory('event', pinData);
          this.pins[pinData.pid] = pin;
          this.bounds.push([pin.lat, pin["long"]]);
        }
      }
    };
    /**
     * @name update
     * @desc update all of the map pins for the layer
     * @param layer
     * @returns
     * @memberOf Map
     */


    Map.prototype.update = function (layer) {
      for (var key in this.pins) {
        if (this.pins.hasOwnProperty(key)) {
          var pin = this.pins[key];
          L.marker([parseFloat(pin.lat), parseFloat(pin["long"])], {
            icon: pin.icon
          }).addTo(layer).bindPopup(pin.text);
        }
      }
    };
    /**
     * Map Layer inherits from Leaflet map
     * @constructor
     */


    function MapLayer() {
      L.LayerGroup.call(this);
    }

    MapLayer.prototype.constructor = MapLayer;
    MapLayer.prototype = Object.create(L.LayerGroup.prototype);
    /**
     * @desc  Default map pin
     * @param lat
     * @param long
     * @param text
     * @param icon
     * @constructor
     */

    function MapPin(lat, _long, text, icon) {
      this.lat = lat || undefined;
      this["long"] = _long || undefined;
      this.text = text || null;
      this.icon = icon || null;
    }
    /**
     * @name setIcon
     * @desc set the pin icon
     * @param pinData
     * @returns pinData
     * @memberOf MapPin
     */


    MapPin.prototype.setIcon = function (pinData) {
      this.icon = L.AwesomeMarkers.icon({
        icon: 'fa-home',
        prefix: 'fa',
        markerColor: 'blue'
      });
    };
    /**
     * @name setText
     * @desc set the map pin text
     * @param text
     * @returns pinData
     * @memberOf MapPin
     */


    MapPin.prototype.setText = function (text) {
      this.text = text;
    };
    /**
     * @desc Inherits from MaPin - pin for events
     * @param args
     * @param event
     * @constructor
     */


    function MapEventPin(args, event) {
      MapPin.call(this, args.lat, args["long"], args.text, args.icon);
      this.title = args.title;
      this.events = [event];
    }

    MapEventPin.prototype.constructor = MapEventPin;
    MapEventPin.prototype = Object.create(MapPin.prototype);
    /**
     * @name setIcon
     * @desc set the pin icon
     * @param pinData
     * @returns pinData
     * @memberOf MapEventPin
     */

    MapEventPin.prototype.setIcon = function (pinData) {
      var icon = L.AwesomeMarkers.icon({
        icon: 'fa-home',
        prefix: 'fa',
        markerColor: 'green'
      });

      if (pinData.eventSourceID) {
        icon = L.AwesomeMarkers.icon({
          icon: 'fa-exclamation-circle',
          prefix: 'fa',
          markerColor: 'blue'
        });
      }

      this.icon = icon;
    };
    /**
     * @name setText
     * @desc Set the html for the pin popup
     * @returns pinData
     * @memberOf MapEventPin
     */


    MapEventPin.prototype.setText = function () {
      var wrapper = $('<div />');
      var ul = $('<ul />').addClass('lr-timeline lr-timeline--overflow lr-timeline--map-pin');
      wrapper.append('<h3>' + this.title + ' </h3>');
      this.events.forEach(function (element) {
        var listItem = ['<li>', '  <div class="lr-timeline__time">', '  </div>', '  <div class="lr-timeline__content">', '    <h3 class="lr-timeline__heading">' + element.pid.substring(0, 30) + '</h3>', '    <h5 class="">' + element.deviceName + '</h5>', '    <h6 class="">' + element.hubName + '</h6>', '    <div class="lr-timeline__date">' + element.dateReceived + '</div>', '    <p>' + element.description + '</p>', '  </div>', '</li>'].join('');
        ul.prepend(listItem);
      });
      wrapper.append(ul);
      this.text = wrapper.html();
    };
    /**
     * @name addEvent
     * @desc adds a matching event to this pin
     * @param event
     * @returns event
     * @memberOf MapEventPin
     */


    MapEventPin.prototype.addEvent = function (event) {
      this.events.push(event);
    };
    /**
     * @desc inherits from MapPin - pin class for properties
     * @param args
     * @constructor
     */


    function MapPropertyPin(args) {
      MapPin.call(this, args.lat, args["long"], args.text, args.icon);
      this.title = args.title;
    }

    MapPropertyPin.prototype.constructor = MapPropertyPin;
    MapPropertyPin.prototype = Object.create(MapPin.prototype);
    /**
     * @name setIcon
     * @desc set the icon for a property map property map
     * @param pinData
     * @memberOf MapPropertyPin
     */

    MapPropertyPin.prototype.setIcon = function (pinData) {
      var state = pinData.state;
      var icon = L.AwesomeMarkers.icon({
        icon: 'fa-home',
        prefix: 'fa',
        markerColor: 'red'
      });

      if (state.CleaningStateID === PropertyStateValue.pending && state.InspectionStateID === PropertyStateValue.pending && state.MaintenanceStateID === PropertyStateValue.pending) {
        this.icon = L.AwesomeMarkers.icon({
          icon: 'fa-home',
          prefix: 'fa',
          markerColor: 'red'
        });
        return;
      }

      if (state.CleaningStateID === PropertyStateValue.inProgress && state.InspectionStateID === PropertyStateValue.inProgress && state.MaintenanceStateID === PropertyStateValue.inProgress) {
        this.icon = L.AwesomeMarkers.icon({
          icon: 'fa-home',
          prefix: 'fa',
          markerColor: 'yellow'
        });
        return;
      }

      if (state.CleaningStateID === PropertyStateValue.readyFor && state.InspectionStateID === PropertyStateValue.readyFor && state.MaintenanceStateID === PropertyStateValue.readyFor) {
        this.icon = L.AwesomeMarkers.icon({
          icon: 'fa-home',
          prefix: 'fa',
          markerColor: 'green'
        });
        return;
      }

      this.icon = icon;
    };
    /**
     * @name setText
     * @desc sets the text to the MapPropertyPin
     * @param data
     * @returns data
     * @memberOf MapPropertyPin
     */


    MapPropertyPin.prototype.setText = function (data) {
      var pinText = '<b>' + data.pid + '</b><br>';
      var state = data.state;

      if (state.GuestStateName) {
        pinText += data.state.GuestStateName + '<br>';
      }

      if (state.CleaningStateID) {
        pinText += 'Cleaning: ' + data.state.CleaningStateName + '<br>';
      }

      if (state.InspectionStateID) {
        pinText += 'Inspection: ' + data.state.InspectionStateName + '<br>';
      }

      if (state.MaintenanceStateID) {
        pinText += 'Maintenance: ' + data.state.MaintenanceStateName + '<br>';
      }

      this.text = pinText;
    };
    /**
     * Creates map pins as needed
     * @param pinType
     * @param pinData
     * @returns {*}MapPin
     */


    function mapPinFactory(pinType, pinData) {
      if (pinType === 'event') {
        //lat, long, text, icon
        var mapEventPin = new MapEventPin({
          lat: pinData.propertyLatitude,
          "long": pinData.propertyLongitude,
          title: pinData.pid
        }, pinData);
        mapEventPin.setIcon(pinData);
        mapEventPin.setText(pinData);
        return mapEventPin;
      } else if (pinType === 'property') {
        var mapPropertyPin = new MapPropertyPin({
          lat: pinData.latitude,
          "long": pinData.longitude,
          title: pinData.pid
        });
        mapPropertyPin.setIcon(pinData);
        mapPropertyPin.setText(pinData);
        return mapPropertyPin;
      } else {
        var mapPin = new MapPin();
        return mapPin;
      }
    }

    return {
      Map: Map,
      MapLayer: MapLayer
    };
  }
})();